export const versoMebelSellerRequisites = {
    name: "ООО «Алфексгрупп»",
    address: "231300,Гродненская обл., г. Лида, ул. Докучаева 63",
    account: "BY27 AKBB 3012 2687 1001 0420 0000",
    bank: "ОАО «АСБ Беларусбанк» ул.Советская 10  код AKBBBY21413",
    unp: "591326871",
    phone: "(8015-4)61-14-52, +375447324144",
};

export const versoMebelContacts = {
    phones: [
        {id: 1, display: "+375 (154) 620-777", href: "tel:+375154620777"},
        {id: 2, display: "+375 (29) 626-00-77", href: "tel:+375296260077"},
    ],
    email: "opt@vmebel.by",
    address: ["Беларусь, г. Лида,", "ул. Докучаева, 63"],
    unp: "591326871",
};

export const versoMebelAboutParagraphs = [
    {
        id: 1,
        text: "«ВерсоМебель» — группа компаний по производству и реализации корпусной и встраиваемой мебели в РБ. Поставляем свою продукцию по всей РБ, а также в РФ. Проект Upme.by — это наш ответ на современные вызовы в сфере изготовления стандартных модульных кухонных гарнитур.",
    },
    {
        id: 2,
        text: "Производство компании расположено на собственной производственной базе в г. Лида. За годы работы мы собрали воедино высокие технологии, высококвалифицированный персонал и эффективный менеджмент.",
    },
    {
        id: 3,
        text: "В 2024 году полностью обновлено производственное оборудование: с помощью новейшего итальянского и немецкого оборудования мы изготавливаем мебель под любые требования современного интерьера.",
    },
    {
        id: 4,
        text: "Одни из первых на рынке внедрили ИИ в производство. Мы подстроились под реалии рынка, учтя все пожелания наших клиентов и представили уникальный сервис. Ваш проект формирует искусственный интеллект: он мгновенно анализирует конструктив, готовит точные чертежи и документацию, полностью исключая риск «человеческого фактора» и ошибок. Высококлассная техника обеспечивает идеальную подгонку деталей. Процесс изготовления полностью автоматизирован. Такой подход позволяет сократить сроки изготовления проекта до 2–4 недель. Правильность и точность изготовления деталей проверяется на каждом этапе вплоть до упаковки.",
    },
    {
        id: 5,
        text: "За более чем 20 лет работы на рынке мы реализовали более 10 000 проектов кухонь. Наши кухни представлены на известных маркетплейсах. Там же вы можете найти реальные отзывы клиентов.",
    },
];
